export const maintenanceCodes = ["503331996", "503331997"];
